import { SET_INITIAL_PROPS } from 'data_system/token_auth/actionTypes';

const defaultState = {
  brand: {},
  partner: {},
};

export const initialPropsReducer = (state = defaultState, action) => {
  const { type, props } = action;

  switch (type) {
    // Loading server-rendered props into state
    case SET_INITIAL_PROPS:
      return props;
    default:
      return state;
  }
};
